import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9mdx220frm: FaireBrandEntity = {
  token: "b_9mdx220frm",
  type: "brand",
  name: "Vertly",
  avatarUrl:
    "https://cdn.faire.com/fastly/c83a1b9ed3946b839c72d7478121cd818ab73c078bd8d11f02c311bf36712d1d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d851ac46678e57e28f0491668724f2df100ac727810c1e5f228aaea69197b1f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c83a1b9ed3946b839c72d7478121cd818ab73c078bd8d11f02c311bf36712d1d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d851ac46678e57e28f0491668724f2df100ac727810c1e5f228aaea69197b1f0.jpeg",
  location: "Marin County, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "At Vertly, we believe in slowing down.\n\nWe’re a small-batch wellness line rooted in Northern California, where everything begins with fresh, locally grown plants. From the herbs we source to the way we craft our products, we prioritize patience, potency, and purpose.\n\nEach batch starts with whole plants—harvested by California farmers and herbalists—then gently extracted over the course of three weeks to draw out their nutrients, antioxidants, and natural benefits. No shortcuts. Just the good stuff, slowly and intentionally made.\n\nThat herbal oil becomes the foundation of every Vertly product—from our muscle-soothing lotions to our glow-boosting face oils and beyond. We blend everything fresh weekly, in small batches, so your skin and body get the most from every botanical.\n\nWhen something is made with care, you feel it. And when your self-care reflects that same energy—fresh ingredients, slow processes, thoughtful rituals—your body responds. We're here to help you slow down, reconnect, and let the plants do what they do best.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:06.473Z",
    importedBy: "entity-db-cli",
  },
};
